function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { sdkLogger } from '../../logger';
import { JsonUtils } from '../../utils/json-utils';
import { JsonAdBreaksProvider } from '../adverts/vod-adverts/json-ad-breaks-provider';
import { TimelineAdvertsAddon } from '../adverts/vod-adverts/timeline-adverts-addon';
export var AdvertsInsertionStageManager = /*#__PURE__*/ function() {
    "use strict";
    function AdvertsInsertionStageManager(session, pauseAdvertDispatcher, adPolicyManager, adBreaksProvider, adInsertionAddon, ssaiAddon) {
        _class_call_check(this, AdvertsInsertionStageManager);
        _define_property(this, "session", void 0);
        _define_property(this, "pauseAdvertDispatcher", void 0);
        _define_property(this, "adPolicyManager", void 0);
        _define_property(this, "adBreaksProvider", void 0);
        _define_property(this, "adInsertionAddon", void 0);
        _define_property(this, "ssaiAddon", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "timelineAdsAddon", void 0);
        _define_property(this, "currentAdBreak", void 0);
        _define_property(this, "currentAd", void 0);
        this.session = session;
        this.pauseAdvertDispatcher = pauseAdvertDispatcher;
        this.adPolicyManager = adPolicyManager;
        this.adBreaksProvider = adBreaksProvider;
        this.adInsertionAddon = adInsertionAddon;
        this.ssaiAddon = ssaiAddon;
        this.logger = sdkLogger.withContext('AdvertsInsertionStageManager');
        this.timelineAdsAddon = null;
        this.currentAdBreak = null;
        this.currentAd = null;
        this.registerAdvertsEvents();
    }
    _create_class(AdvertsInsertionStageManager, [
        {
            key: "registerAdvertsEvents",
            value: function registerAdvertsEvents() {
                var _this = this;
                this.session.onAdBreakStarted(function(adBreak) {
                    _this.currentAdBreak = adBreak;
                });
                this.session.onAdStarted(function(ad) {
                    _this.currentAd = ad;
                });
                this.session.onAdFinished(function() {
                    _this.currentAd = null;
                });
                this.session.onAdBreakFinished(function(adBreak) {
                    _this.currentAdBreak = null;
                });
            }
        },
        {
            key: "fetchAdvertisementData",
            value: function fetchAdvertisementData(populatedPlayoutData, initialPlayoutData, playerAdsCapabilities) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_adInsertionAddon, _this_adPolicyManager, _this_adBreaksProvider, _modifiedPlayoutData_advertising_vac, _modifiedPlayoutData_advertising, modifiedPlayoutData, sleCsai;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (populatedPlayoutData.adsFailoverReason) {
                                    _this.logger.warn("Error Fetching Advertising data. Destroying Adverts Manager: ".concat(JsonUtils.stringify(populatedPlayoutData.adsFailoverReason)));
                                    return [
                                        2,
                                        populatedPlayoutData
                                    ];
                                }
                                (_this_adInsertionAddon = _this.adInsertionAddon) === null || _this_adInsertionAddon === void 0 ? void 0 : _this_adInsertionAddon.setAdvertising(populatedPlayoutData.advertising);
                                // "Modified" playout data has had existing properties modified by the addons e.g. CDN url
                                modifiedPlayoutData = populatedPlayoutData;
                                if (!(initialPlayoutData.vamMidrollEnabled === false)) return [
                                    3,
                                    1
                                ];
                                _this.logger.warn('Midrolls disabled by OVP. Using initial playout data.');
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.modifyPlayoutData(populatedPlayoutData)
                                ];
                            case 2:
                                modifiedPlayoutData = _state.sent();
                                _state.label = 3;
                            case 3:
                                (_this_adPolicyManager = _this.adPolicyManager) === null || _this_adPolicyManager === void 0 ? void 0 : _this_adPolicyManager.initialise(_this.session.onPlaybackTimelineUpdated.bind(_this.session));
                                (_this_adBreaksProvider = _this.adBreaksProvider) === null || _this_adBreaksProvider === void 0 ? void 0 : _this_adBreaksProvider.setPlayoutData(modifiedPlayoutData);
                                sleCsai = (_modifiedPlayoutData_advertising = modifiedPlayoutData.advertising) === null || _modifiedPlayoutData_advertising === void 0 ? void 0 : (_modifiedPlayoutData_advertising_vac = _modifiedPlayoutData_advertising.vac) === null || _modifiedPlayoutData_advertising_vac === void 0 ? void 0 : _modifiedPlayoutData_advertising_vac.sleCsai;
                                if (sleCsai) {
                                    // Preroll should only have one avail
                                    if (modifiedPlayoutData.adInsertionConfig && !playerAdsCapabilities.supportsNativeCsai) {
                                        modifiedPlayoutData.adInsertionConfig.isTimelineAdManagementRequired = true;
                                    }
                                    _this.timelineAdsAddon = new TimelineAdvertsAddon(new JsonAdBreaksProvider(), _this.session, initialPlayoutData.type, _this.pauseAdvertDispatcher, initialPlayoutData);
                                    _this.timelineAdsAddon.setAdvertising(modifiedPlayoutData.advertising);
                                }
                                return [
                                    2,
                                    modifiedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "modifyPlayoutData",
            value: function modifyPlayoutData(populatedPlayoutData) {
                var _this = this;
                return _async_to_generator(function() {
                    var e, message, code;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.ssaiAddon) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.ssaiAddon.getModifiedPlayout(populatedPlayoutData)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                e = _state.sent();
                                message = 'Error getting modified playout data, ads may not be shown';
                                _this.logger.warn(message, JsonUtils.stringify(e));
                                code = 'SDK.ADVERTSMGR.SETUP_ADS.SSAI.GET_MODIFIED_PLAYOUT_DATA';
                                _this.session.notifyWarning(code, message);
                                populatedPlayoutData.adsFailoverReason = _this.ssaiAddon.getAdsFailoverReason();
                                return [
                                    2,
                                    populatedPlayoutData
                                ];
                            case 4:
                                return [
                                    2,
                                    populatedPlayoutData
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getTimelineAdsAddon",
            value: function getTimelineAdsAddon() {
                return this.timelineAdsAddon;
            }
        },
        {
            key: "getCurrentAd",
            value: function getCurrentAd() {
                return this.currentAd;
            }
        },
        {
            key: "getCurrentAdBreak",
            value: function getCurrentAdBreak() {
                return this.currentAdBreak;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_timelineAdsAddon;
                this.currentAd = null;
                this.currentAdBreak = null;
                (_this_timelineAdsAddon = this.timelineAdsAddon) === null || _this_timelineAdsAddon === void 0 ? void 0 : _this_timelineAdsAddon.destroy();
                this.timelineAdsAddon = null;
            }
        }
    ]);
    return AdvertsInsertionStageManager;
}();

//# sourceMappingURL=adverts-insertion-stage-manager.js.map